import {
  openRecordingControlAttempt,
  type RecordingControlSurface,
  type RecordingControlTracking,
} from '@/lib/telemetry/recordingControlTracking';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { TrackingKey } from '@heidi/runtime/performance';
import { GET_SESSION_BY_ID, type QuerySessionResponse } from '@heidi/session/contracts';

// Kept apart from recordingControlTracking so its closers, imported by every
// recorder hook, do not pull in the app query client. Read inside the opener's
// guard: a cache throw must not block the control.
const isTabSharingSession = (sessionId: string): boolean =>
  Boolean(
    reactQueryClient.getQueryData<QuerySessionResponse>([
      GET_SESSION_BY_ID,
      { sessionId },
    ])?.is_tab_sharing
  );

/** Opens a pause attempt with the metadata every surface records. */
export const openRecordingPauseAttempt = (
  sessionId: string,
  controlSurface: RecordingControlSurface
): RecordingControlTracking | undefined =>
  openRecordingControlAttempt(TrackingKey.SCRIBE_PAUSE_RECORDING, () => ({
    isTabSharing: isTabSharingSession(sessionId),
    controlSurface,
  }));

/** Opens a stop attempt with the metadata every surface records. */
export const openRecordingStopAttempt = (
  sessionId: string,
  controlSurface: RecordingControlSurface,
  fromPaused: boolean
): RecordingControlTracking | undefined =>
  openRecordingControlAttempt(TrackingKey.SCRIBE_STOP_RECORDING, () => ({
    isTabSharing: isTabSharingSession(sessionId),
    fromPaused,
    controlSurface,
  }));
